var map = {
	"./about-commitment.webp": 49817,
	"./about-mission.webp": 80850,
	"./about-us-bg.webp": 50836,
	"./about-vision.webp": 4632,
	"./adobexd.svg": 11089,
	"./aftereffects.svg": 3720,
	"./agile-software.svg": 67410,
	"./agri.webp": 59605,
	"./ai-chat.svg": 26697,
	"./ai-development.svg": 17414,
	"./ai-icon.svg": 51184,
	"./ai-ml-develop.svg": 8564,
	"./ai-ml.webp": 73024,
	"./alibaba.svg": 84116,
	"./android-app.svg": 15371,
	"./android-right.svg": 54224,
	"./angular.svg": 53198,
	"./ansible.svg": 59432,
	"./apache.svg": 29610,
	"./apple.svg": 42916,
	"./aptos.webp": 82442,
	"./arbitrum.webp": 47990,
	"./arrow-white.svg": 35575,
	"./arrow.svg": 8215,
	"./avalanche.webp": 60077,
	"./aws.svg": 57907,
	"./backend-icon.svg": 92310,
	"./banking.webp": 40694,
	"./binance.webp": 46406,
	"./bitcoin.webp": 38986,
	"./blender.svg": 32036,
	"./blockchain-icon.svg": 60,
	"./bootstrap.svg": 65910,
	"./branding.svg": 48477,
	"./brownie.svg": 30830,
	"./burp-suite.svg": 87670,
	"./c-program.svg": 87324,
	"./cardIcon.png": 16111,
	"./cardIcon.svg": 63085,
	"./cardImg.png": 51395,
	"./cardImgThree.webp": 43883,
	"./cardImgTwo.webp": 24997,
	"./cardano.webp": 64246,
	"./career-bg.webp": 53226,
	"./cassandra.svg": 76626,
	"./chef.svg": 37912,
	"./circleci.svg": 6304,
	"./cloud-icon.svg": 71763,
	"./computer-vision.svg": 80832,
	"./construction.webp": 29425,
	"./contact-img.svg": 32498,
	"./contact-line-one.svg": 6092,
	"./contact-line-two.svg": 32878,
	"./contact-temple.svg": 49954,
	"./content-marketing.svg": 84860,
	"./cosmos.webp": 32996,
	"./cplus-bg.svg": 77969,
	"./cplus.svg": 48615,
	"./cprogram-bg.svg": 75911,
	"./crm.svg": 17152,
	"./crypto-payment.svg": 14506,
	"./crypto-token.svg": 83215,
	"./css.svg": 62185,
	"./cucumber.svg": 62944,
	"./custom-software.svg": 38349,
	"./custom-trading.svg": 59677,
	"./database-icon.svg": 8591,
	"./design-icon.svg": 44936,
	"./devops-icon.svg": 80379,
	"./digital-marketing.webp": 72185,
	"./digital-ocean.svg": 13389,
	"./dl.svg": 93676,
	"./docker.svg": 47192,
	"./drop-agri.svg": 42791,
	"./drop-agri.webp": 76309,
	"./drop-construction.svg": 94123,
	"./drop-construction.webp": 31217,
	"./drop-edu.svg": 50568,
	"./drop-edu.webp": 54852,
	"./drop-energy.svg": 57632,
	"./drop-energy.webp": 96044,
	"./drop-entertainment.svg": 45150,
	"./drop-entertainment.webp": 42690,
	"./drop-events.svg": 64575,
	"./drop-events.webp": 66269,
	"./drop-game.svg": 53714,
	"./drop-game.webp": 96446,
	"./drop-health.svg": 54678,
	"./drop-health.webp": 88778,
	"./drop-legal.svg": 87407,
	"./drop-logistics.svg": 89981,
	"./drop-logistics.webp": 2595,
	"./drop-ondemand.svg": 7930,
	"./drop-ondemand.webp": 61654,
	"./drop-realestate.svg": 56600,
	"./drop-realestate.webp": 74420,
	"./drop-restaurant.svg": 30041,
	"./drop-restaurant.webp": 18951,
	"./drop-retail.svg": 69561,
	"./drop-retail.webp": 40743,
	"./drop-travel.svg": 66848,
	"./drop-travel.webp": 34860,
	"./dropdown-ai.webp": 84554,
	"./dropdown-bank.svg": 75534,
	"./dropdown-bank.webp": 35026,
	"./dropdown-blockchain.webp": 96094,
	"./dropdown-finance.svg": 70,
	"./dropdown-finance.webp": 28410,
	"./dropdown-insurance.svg": 608,
	"./dropdown-insurance.webp": 36396,
	"./dropdown-legal.webp": 58397,
	"./dynamo.svg": 44882,
	"./education.webp": 90858,
	"./energy.webp": 87212,
	"./entertainment.webp": 62658,
	"./erp-software.svg": 62843,
	"./eth.webp": 11811,
	"./event.webp": 48872,
	"./explore-head-img.svg": 85390,
	"./figma.svg": 62896,
	"./finance.webp": 29834,
	"./float-card-img-five.webp": 61336,
	"./float-card-img-four.webp": 30796,
	"./float-card-img-three.webp": 86792,
	"./float-card-img-two.webp": 82622,
	"./float-card-img.webp": 47721,
	"./flutter.svg": 93374,
	"./fogbugz.svg": 38012,
	"./forex-algorithm.svg": 21434,
	"./forex-trading-app.svg": 14288,
	"./forex-trading.webp": 78670,
	"./form-bg.webp": 43102,
	"./frontend-icon.svg": 56602,
	"./game.webp": 73713,
	"./gemini.svg": 33769,
	"./generative-ai.svg": 62125,
	"./git.svg": 46660,
	"./go-bg.svg": 34082,
	"./go.svg": 98310,
	"./googlecloud.svg": 12144,
	"./grafana.svg": 67156,
	"./granche.svg": 44972,
	"./guide-img.webp": 48026,
	"./guide-subcardOne-crown.webp": 56189,
	"./guide-subcardOne-mask.png": 13654,
	"./guide-subcardOne.webp": 18999,
	"./guide-subcardThree.webp": 40675,
	"./guide-subcardTwo.webp": 59805,
	"./hardhat.svg": 36586,
	"./health.webp": 79946,
	"./hero-curve.svg": 56798,
	"./hero-underline.svg": 97615,
	"./html.svg": 11347,
	"./hyperleadger.svg": 44142,
	"./ibm.svg": 45066,
	"./ico.svg": 37003,
	"./illustrator.svg": 14523,
	"./ind-image.png": 55895,
	"./insurance.webp": 88764,
	"./ionic.svg": 37482,
	"./ios-app.svg": 40861,
	"./jenkins.svg": 14242,
	"./jira.svg": 68520,
	"./kafka.svg": 77142,
	"./keras.svg": 69598,
	"./kubernetes.svg": 76384,
	"./landing-mail.svg": 97095,
	"./landing-phone.svg": 58650,
	"./landing-telegram.svg": 4987,
	"./landing-whatsapp.svg": 74364,
	"./laravel.svg": 13395,
	"./legal.webp": 50541,
	"./logistics.webp": 82435,
	"./maya.svg": 19524,
	"./memcache.svg": 98247,
	"./microservice.svg": 29073,
	"./microsoftazure.svg": 38445,
	"./migration.svg": 45152,
	"./ml.svg": 91044,
	"./mobile-app-icon.svg": 40658,
	"./mobile.webp": 56862,
	"./mongo.svg": 82524,
	"./mt.svg": 40751,
	"./mysql.svg": 12006,
	"./near.webp": 63094,
	"./nearshore-software.svg": 20265,
	"./next.svg": 11439,
	"./nft.svg": 67276,
	"./nlp.svg": 92982,
	"./node-bg.svg": 18864,
	"./node.svg": 13688,
	"./nuxt.svg": 88575,
	"./offshore-development.svg": 26202,
	"./on-demand.webp": 47287,
	"./openai.svg": 43334,
	"./opencv.svg": 3739,
	"./oracle.svg": 85274,
	"./photoshop.svg": 9500,
	"./php.svg": 21980,
	"./polkadot.webp": 38154,
	"./polygon.webp": 72546,
	"./postgre.svg": 88686,
	"./postman.svg": 83462,
	"./progressive-app.svg": 27075,
	"./prometheus.svg": 47268,
	"./protractor.svg": 6810,
	"./puppet.svg": 23974,
	"./pwa.svg": 64696,
	"./python-bg.svg": 56078,
	"./python.svg": 9962,
	"./pytorch.svg": 81793,
	"./rabbitmq.svg": 97850,
	"./react-native.svg": 64191,
	"./react.svg": 75281,
	"./real-estate.webp": 46639,
	"./redis.svg": 6221,
	"./reinforcement.svg": 26495,
	"./restaurant.webp": 49831,
	"./retail.webp": 31911,
	"./ripple.webp": 8798,
	"./ruby-bg.svg": 88524,
	"./ruby.svg": 85388,
	"./rust-bg.svg": 64418,
	"./rust.svg": 71558,
	"./scikit.svg": 78249,
	"./selenium.svg": 89928,
	"./seo.svg": 50815,
	"./sketch.svg": 96568,
	"./slider-agri.svg": 2887,
	"./slider-agriTwo.svg": 61483,
	"./slider-ai.svg": 88070,
	"./slider-bank.svg": 58942,
	"./slider-block.svg": 73615,
	"./slider-construction.svg": 84619,
	"./slider-demand.svg": 23141,
	"./slider-edu.svg": 32264,
	"./slider-energy.svg": 15520,
	"./slider-energyTwo.svg": 82294,
	"./slider-entertain.svg": 88942,
	"./slider-events.svg": 56319,
	"./slider-finance.svg": 33622,
	"./slider-game.svg": 88946,
	"./slider-health.svg": 10646,
	"./slider-insurance.svg": 74608,
	"./slider-legal.svg": 27343,
	"./slider-logistics.svg": 74109,
	"./slider-logisticsTwo.svg": 49445,
	"./slider-realestate.svg": 64984,
	"./slider-restaurant.svg": 26073,
	"./slider-retail.svg": 71737,
	"./slider-travel.svg": 56032,
	"./slider-webThree.svg": 88150,
	"./slider-webTwo.svg": 4696,
	"./smart-contract.svg": 27894,
	"./software.webp": 62361,
	"./solana.webp": 72532,
	"./solidity.svg": 1071,
	"./spline.svg": 94399,
	"./stellar.webp": 90969,
	"./svelte.svg": 60425,
	"./tech-right-angular.svg": 9228,
	"./tech-right-css.svg": 23175,
	"./tech-right-html.svg": 41182,
	"./tech-right-next.svg": 23553,
	"./tech-right-nuxt.svg": 78417,
	"./tech-right-react.svg": 59915,
	"./tech-right-svelete.svg": 52374,
	"./tech-right-vue.svg": 2786,
	"./techstack-grid.svg": 68653,
	"./techstack-gridtwo.svg": 88373,
	"./techstack-lineOne.svg": 60121,
	"./techstack-lineTwo.svg": 83087,
	"./tensorflow.svg": 49279,
	"./testing-icon.svg": 28962,
	"./testng.svg": 18285,
	"./trading-bot.svg": 98983,
	"./travel.webp": 26028,
	"./tron.webp": 86651,
	"./truffle.svg": 17290,
	"./vue.svg": 28316,
	"./web-app.svg": 10108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59388;